import { FormattedMessage } from 'react-intl'
import { Icon } from 'semantic-ui-react'
import styled from 'styled-components'

import { StyledDivider } from '@/pages/SpaceAppBuilder/components/StyledComponents'

import DataCollectionFieldRow from './DataCollectionFieldRow'
import { DataCollectionTypes, FactTypes } from './DataCollectionSet'
import messages from './messages'

const AccordionTitle = styled.div`
  padding-bottom: 5px;
  padding-top: 25px;
  cursor: pointer;
  font-size: 0.85rem;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  &:first-child {
    margin-top: 0;
  }
`

const StyledSubDivider = styled(StyledDivider)`
  margin: 0 0 0.75rem 0;
  padding-left: 5px;
`

interface DataCollectionFieldsAccordionProps {
  allFields: FactTypes[] | undefined
  dataCollectionSet: DataCollectionTypes
  toggleAccordion: () => void
  showCollectionFields: boolean
  updateCollectionSet: (field: FactTypes) => void
  readOnly?: boolean
}

const DataCollectionFieldsAccordion = ({
  allFields,
  dataCollectionSet,
  toggleAccordion,
  showCollectionFields,
  updateCollectionSet,
  readOnly = false
}: DataCollectionFieldsAccordionProps) => {
  const isFactInDataSetCollection = (field: FactTypes) => {
    return dataCollectionSet.facts?.some((fact: FactTypes) => fact.value === field.value)
  }

  return (
    <div data-testid="collectionSetEntry">
      <AccordionTitle
        onClick={() => {
          toggleAccordion()
        }}
      >
        <FormattedMessage {...messages.selectDataCollectionFields} />
        {showCollectionFields ? <Icon name="chevron down" size="small" /> : <Icon name="chevron up" size="small" />}
      </AccordionTitle>
      <StyledSubDivider />
      {showCollectionFields &&
        allFields?.map((field, index) => (
          <DataCollectionFieldRow
            key={`${field.value}-${index}`}
            field={field}
            isInDataSetCollection={isFactInDataSetCollection(field)}
            updateCollectionSet={updateCollectionSet}
            readOnly={readOnly}
          />
        ))}
    </div>
  )
}

export default DataCollectionFieldsAccordion
